// EditCompany.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Building } from 'lucide-react';
import './Company.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const EditCompany = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    companyname: "",
    acronym: "",
    companytype: "",
    currentmanager: "",
    contact: "",
    companylocation: "",
    companylogo: null,
    companyseal: null,
    companysignature: null
  });

  const [preview, setPreview] = useState({
    companylogo: "",
    companyseal: "",
    companysignature: ""
  });

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await axios.get(`${url}/api/company/${id}`);
        const company = response.data.data;
        setData({
          companyname: company.companyname,
          acronym: company.acronym || "",
          companytype: company.companytype,
          currentmanager: company.currentmanager || "",
          contact: company.contact || "",
          companylocation: company.companylocation || "",
          companylogo: null,
          companyseal: null,
          companysignature: null
        });
        setPreview({
          companylogo: company.companylogo ? `${url}/uploads/${company.companylogo}` : "",
          companyseal: company.companyseal ? `${url}/uploads/${company.companyseal}` : "",
          companysignature: company.companysignature ? `${url}/uploads/${company.companysignature}` : ""
        });
      } catch (error) {
        toast.error("Failed to load company data");
        navigate('/ViewCompany');
      }
    };

    fetchCompany();
  }, [id, navigate]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setData(prev => ({ ...prev, [name]: files[0] }));
      setPreview(prev => ({ ...prev, [name]: URL.createObjectURL(files[0]) }));
    } else {
      setData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (data[key] !== null) formData.append(key, data[key]);
      });

      const response = await axios.put(
        `${url}/api/company/${id}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.success) {
        toast.success("Company updated successfully!");
        navigate('/ViewCompany');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update company");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="company-form-container">
        <h2 className="form-title">
          <Building size={20} className="inline mr-2" /> Edit Company
        </h2>
        
        <form className="company-form" onSubmit={handleSubmit}>
          <div className="form-field filled">
            <input
              type="text"
              name="companyname"
              value={data.companyname}
              onChange={handleChange}
              required
            />
            <label>Company Name</label>
          </div>

          <div className="form-field">
            <input
              type="text"
              name="acronym"
              value={data.acronym}
              onChange={handleChange}
            />
            <label>Acronym</label>
          </div>

          <div className="form-field filled">
            <input
              type="text"
              name="companytype"
              value={data.companytype}
              onChange={handleChange}
              required
            />
            <label>Company Type</label>
          </div>

          <div className="form-field">
            <input
              type="text"
              name="currentmanager"
              value={data.currentmanager}
              onChange={handleChange}
            />
            <label>Current Manager</label>
          </div>

          <div className="form-field">
            <input
              type="text"
              name="contact"
              value={data.contact}
              onChange={handleChange}
            />
            <label>Contact</label>
          </div>

          <div className="form-field">
            <input
              type="text"
              name="companylocation"
              value={data.companylocation}
              onChange={handleChange}
            />
            <label>Company Location</label>
          </div>

          <div className="form-field">
            <label>Company Logo</label>
            <input type="file" name="companylogo" onChange={handleChange} />
            {preview.companylogo && <img src={preview.companylogo} alt="Logo" width="80" />}
          </div>

          <div className="form-field">
            <label>Company Seal</label>
            <input type="file" name="companyseal" onChange={handleChange} />
            {preview.companyseal && <img src={preview.companyseal} alt="Seal" width="80" />}
          </div>

          <div className="form-field">
            <label>Company Signature</label>
            <input type="file" name="companysignature" onChange={handleChange} />
            {preview.companysignature && <img src={preview.companysignature} alt="Signature" width="80" />}
          </div>

          <div className="button-group">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate('/Company')}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="submit-btn" 
              disabled={submitting}
            >
              {submitting ? "Updating..." : "Update Company"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCompany;
